import React from 'react';
import ModuleTable from 'Components/Core/ModuleTable';
import FormElement from 'Components/Core/Form/FormElement';
import MarketdataGroupSelector from './MarketdataGroupSelector';
import './Marketdata.css';

export default function MarketdataWatchlist(props) {

	const x = props.x;
	const wafId = props.id;
	const dialogFormId = "form-" + props.id;
	const [reloadKey, setReloadKey] = React.useState(0);
	const [selectedGroupId, setSelectedGroupId] = React.useState(null);

	// Mehrere Watchlists (Gruppen) statt einer einzigen globalen Liste - bewusst
	// ohne eigenen Menüpunkt (User-Vorgabe), stattdessen eine Auswahlbox direkt
	// hier und im Pendant MarketdataQuotes.js (siehe MarketdataGroupSelector.js).
	function changeGroup(groupId) {
		setSelectedGroupId(groupId);
		setReloadKey((current) => current + 1);
	}

	// Nach Drag-and-Drop-Umsortierung (siehe draggableRows/onReorder in
	// Table.js) die neue Reihenfolge als sortorder=Index speichern und die
	// Tabelle danach neu laden, damit die angezeigte "Sortierung"-Spalte
	// wieder zu den tatsaechlichen Werten passt (Table.js selbst zeigt die
	// neue Reihenfolge zwar sofort an, aber mit den alten sortorder-Zahlen).
	function handleReorder(newData) {
		const order = newData.map((row) => row.watchlistid);
		x.was.axPost('Backend/webapp.php?module=Marketdata&task=MarketdataWatchlistReorder', { order }, (result) => {
			if (result.data.returncode === 1) {
				setReloadKey((current) => current + 1);
			}
		});
	}

	const formFields =
		<React.Fragment>
			<HiddenGroupField x={x} wafId={wafId} groupId={selectedGroupId} />
			<SymbolSearch x={x} wafId={wafId} />
			<FormElement type="text" x={x} wafId={wafId} id="symbol" mandatory={true} title="Symbol (z.B. AAPL)" fieldValue="" maxLength="20" />
			<FormElement type="text" x={x} wafId={wafId} id="shortlabel" mandatory={false} title="Kurzbezeichnung (z.B. Gold)" fieldValue="" maxLength="20" />
			<FormElement type="text" x={x} wafId={wafId} id="exchange" mandatory={false} title="Börse" fieldValue="US" maxLength="20" />
			<FormElement type="text" x={x} wafId={wafId} id="label" mandatory={false} title="Bezeichnung" fieldValue="" maxLength="100" />
			<FormElement type="text" x={x} wafId={wafId} id="sortorder" mandatory={false} title="Sortierung" fieldValue="0" maxLength="5" />
		</React.Fragment>

	const watchlistSelector =
		<MarketdataGroupSelector x={x} id={props.id} onSelect={changeGroup} />

	return (
		<ModuleTable
			id={props.id}
			tableId="watchlistid"
			dialogFormId={dialogFormId}
			x={x}
			classes="module-marketdata-watchlist"
			tableClasses="marketdata-watchlist-table"
			title={props.title}
			extraToolbar={watchlistSelector}
			addDeleteRow={true}
			addTitle="Symbol zur Watchlist hinzufügen"
			formTitle="Watchlist-Symbol"
			focusField="symbolsearch"
			module="Marketdata"
			listTask="MarketdataWatchlistList"
			listParams={'&groupid=' + selectedGroupId}
			deleteTask="MarketdataWatchlistDelete"
			reloadKey={reloadKey}
			draggableRows={true}
			onReorder={handleReorder}
			onAddHeader={(addHeader) => {
				addHeader('Symbol');
				addHeader('Kurzbez.');
				addHeader('Börse');
				addHeader('Bezeichnung');
				addHeader('Sortierung');
				addHeader('ISIN');
			}}
			onAddColumn={(key, value) => {
				switch (key) {
					case 'watchlistid':
						return false;
					case 'symbol':
						return value;
					case 'shortlabel':
						return value;
					case 'exchange':
						return value;
					case 'label':
						return value;
					case 'sortorder':
						return value;
					case 'isin':
						return value || '–';
					// comdirectinstrumentid steuert hier nichts mehr - der "Kaufen"-
					// Button ist in die Live-Ansicht umgezogen (Chat vom 2026-07-26,
					// siehe MarketdataQuotes.js), die Watchlist-Verwaltung ist reine
					// Stammdatenpflege.
					case 'comdirectinstrumentid':
						return false;
					default:
						return false;
				}
			}}
			onEditRow={(e, rowFields, rowId) => {
				x.waf.setAddSend(wafId, 'id', rowFields.watchlistid);
				x.waf.set(wafId, 'symbol', rowFields.symbol);
				x.waf.set(wafId, 'shortlabel', rowFields.shortlabel);
				x.waf.set(wafId, 'exchange', rowFields.exchange);
				x.waf.set(wafId, 'label', rowFields.label);
				x.waf.set(wafId, 'sortorder', rowFields.sortorder);
				x.waf.hide(wafId, 'message');
				x.wad[dialogFormId].setTitle("Watchlist-Symbol bearbeiten");
				x.wad[dialogFormId].show(() => { x.waf.focus(wafId, 'symbol') });
			}}
			formFields={formFields}
			formSendTask="MarketdataWatchlistSave"
		/>
	)

};

// Symbol-/Namenssuche (debounced, deckt Aktien, Krypto, Indizes und Futures ab
// - nicht nur Firmen) oberhalb des eigentlichen Symbol-Felds - eine Auswahl
// befuellt Symbol/Boerse/Bezeichnung automatisch ueber x.waf.set(), das
// darunterliegende Symbol-Feld bleibt trotzdem manuell editierbar (z.B. falls
// der Ticker schon bekannt ist und keine Suche noetig ist).
function SymbolSearch({ x, wafId }) {
	const [query, setQuery] = React.useState('');
	const [results, setResults] = React.useState([]);
	const debounceRef = React.useRef(null);
	const searchSequence = React.useRef(0);
	const inputRef = React.useRef(null);

	// Als eigenes Feld bei x.waf registrieren (wie FormElement.js es tut),
	// damit ModuleTable's focusField="symbolsearch" (siehe addRow() in
	// ModuleTable.js) x.waf.focus(wafId, 'symbolsearch') darauf anwenden kann -
	// ohne diese Registrierung kennt x.waf dieses Feld nicht und focus()
	// wuerde stillschweigend nichts tun.
	React.useEffect(() => {
		x.waf.initField(wafId, 'symbolsearch', inputRef, '', 'symbolsearch');
	}, [x, wafId]);

	function handleChange(e) {
		const value = e.target.value;
		setQuery(value);
		if (debounceRef.current) {
			clearTimeout(debounceRef.current);
		}
		if (value.trim().length < 2) {
			searchSequence.current += 1;
			setResults([]);
			return;
		}
		// Sequenznummer je Anfrage - der Debounce verhindert nur UEBERLAPPENDE
		// Timer, nicht ueberlappende Requests: tippt man waehrend eine Anfrage
		// noch unterwegs ist weiter, koennen zwei Requests gleichzeitig laufen.
		// Kommt die AELTERE Antwort (kuerzere/andere Suche) dann NACH der
		// neueren zurueck, ueberschreibt sie sonst faelschlich das aktuelle
		// Ergebnis - genau das sichtbare "kurz richtige Liste, dann von falscher
		// ueberschrieben"-Flackern. Nur die zuletzt gestartete Anfrage darf das
		// Ergebnis noch uebernehmen.
		searchSequence.current += 1;
		const currentSequence = searchSequence.current;
		debounceRef.current = setTimeout(() => {
			x.was.axPost('Backend/webapp.php?module=Marketdata&task=MarketdataSymbolSearch', { query: value }, (result) => {
				if (currentSequence !== searchSequence.current) {
					return;
				}
				if (result.data.returncode === 1) {
					setResults(result.data.content || []);
				}
			});
		}, 300);
	}

	function selectResult(row) {
		x.waf.set(wafId, 'symbol', row.symbol);
		x.waf.set(wafId, 'exchange', row.exchange);
		x.waf.set(wafId, 'label', row.name);
		// Kurzbezeichnung mit Bezeichnung vorbelegen - erspart erneutes Tippen,
		// bleibt aber editierbar (z.B. um sie wie bei Gold/Silber zu kuerzen).
		// Programmatisches x.waf.set() umgeht das maxLength="20" des Feldes
		// (das nur Tastatureingaben begrenzt) - der volle FMP-Firmenname
		// (z.B. "Barrick Gold Corporation") ueberschreitet sonst die
		// shortlabel-Spalte (VARCHAR(20)) und das Speichern schlaegt fehl.
		x.waf.set(wafId, 'shortlabel', row.name.slice(0, 20));
		setQuery('');
		setResults([]);
	}

	return (
		<div className="marketdata-symbol-search">
			<label className="marketdata-symbol-search-label">Symbol oder Name suchen</label>
			<input
				ref={inputRef}
				type="text"
				className="form-control rounded-pill"
				value={query}
				onChange={handleChange}
				placeholder="z.B. Apple, AAPL, Bitcoin, Gold"
				autoComplete="off"
			/>
			{results.length > 0 &&
				<ul className="marketdata-symbol-search-results">
					{results.map((row) => (
						<li key={row.symbol} onClick={() => selectResult(row)}>
							<strong>{row.symbol}</strong> <span>{row.name}</span>
						</li>
					))}
				</ul>
			}
		</div>
	);
}


// Unsichtbares Feld, das die aktuell ausgewaehlte Watchlist (groupid) beim
// Anlegen/Bearbeiten eines Symbols mitschickt - der Nutzer waehlt die
// Watchlist ueber die Auswahlbox im Toolbar, nicht im Dialog selbst.
function HiddenGroupField({ x, wafId, groupId }) {
	const inputRef = React.useRef(null);

	React.useEffect(() => {
		x.waf.initField(wafId, 'groupid', inputRef, '', 'groupid');
	}, [x, wafId]);

	React.useEffect(() => {
		if (groupId !== null && x.waf.isField(wafId, 'groupid')) {
			x.waf.set(wafId, 'groupid', groupId, true);
		}
	}, [x, wafId, groupId]);

	return <input type="hidden" ref={inputRef} />;
}
